import 'view/css/operation.css';

import React, { useEffect, useState } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash, faPlus } from '@fortawesome/free-solid-svg-icons';

import API from 'service/api';
import { enterPressed } from 'service/util';

import ModalScreen from 'component/ModalScreen';
import CustomerSelectModal from 'component/service/CustomerSelectModal';

import VehicleCard from 'component/VehicleCard';
import VehicleEdit from 'component/VehicleEdit';
import BillList from 'component/BillList';

import OwnerInfo from 'component/service/OwnerInfo';
import ServiceEdit from 'component/service/ServiceEdit';
import PaymentList from 'component/service/PaymentList';
import OrderList from 'component/service/OrderList';
import NewCustomerPanel from 'component/service/NewCustomerPanel';
import AddVehicleModal from 'component/AddVehicleModal';
import LCRModal from 'component/LCRModal';

import PopMessage from 'component/pop-msg/PopMessage';


import { useNavigate, useParams } from 'react-router-dom';


//-----------------------------------------------------------------
const ServiceView = (props) =>
{
  const params = useParams();
  const navigate = useNavigate();

  const [showAllVh, setShowAllVehicles] = useState(false);

  const [attempt, setAttempt] = useState(null);
  const [search_license, setSearchLicense] = useState( String(params.license||'').toUpperCase() );
  const [search_owner,   setSearchOwner  ] = useState( params.owner_id||null );

  const [owner,       setOwner  ] = useState(null);
  const [sel_vehicle, setVehicle] = useState(null);

  const [billData,   setBillData  ] = useState(null);
  const [modal,      setModal     ] = useState(null);
  const [modalTitle, setModalTitle] = useState('');

  const ref_contact = React.createRef();
  const ref_license = React.createRef();

  const onCustCreated = (cust) =>
  {
    const license = cust.vehicles[0].cd_license;
    setSearchLicense('');
    setSearchLicense(license);
    executeSearch(license);
  }
  const refreshService = (items) => {
    sel_vehicle.services = items;
    setVehicle({...sel_vehicle});
  }
  const refreshBillPayment = () => {
    setBillData(null);
    API.getBills(owner.id).then(data => {
      data.payments.forEach(iv => iv.pay_month = iv.pay_month ? JSON.parse(iv.pay_month) : null);
      setBillData(data);
    });
  }
  const searchLicense = () =>
  {
    let license = ref_license.current.value.trim().toUpperCase();
    if (!license) return;
    setSearchOwner(null);
    setSearchLicense(license);
  }
  const searchContact = () =>
  {
    let contact = ref_contact.current.value.trim();
    if (!contact) return;

    API.findContactOwner(contact).then(resp => {
      if (resp.success)
      {
        let cust = resp.msg;
        if (1 == cust.length)
        { applyOwner(cust[0]); } // apply customer
        else
        {
          // show list and choose
          let modal = <CustomerSelectModal customers={resp.msg} onSelect={applyOwner} />
          setModal(modal);
          setModalTitle('選擇客戶');
        }
      } else {
        PopMessage.show(`無法配對聯絡資料。`, '搜尋', 'danger');
      }
    });
  }

  const applyOwner = (owner) =>
  {
    owner.vehicles.forEach(v =>
    {
      // convert services
      v.services.forEach(s => {
        s.start_dtm = new Date(s.start_dtm);
        if (s.end_dtm) s.end_dtm = new Date(s.end_dtm);
      });
    });

    // sort vehicles by license number
    owner.vehicles.sort((a,b) => {
      if (a.cd_license > b.cd_license) return  1;
      if (a.cd_license < b.cd_license) return -1;
      return 0;
    });

    // find the target vehicle
    let _selVh;
    if (search_license) {
      _selVh = owner.vehicles.filter(v => v.cd_license === search_license)[0];
    }
    const vehicle = _selVh ?? owner.vehicles[0];
    setVehicle( vehicle );

    // display
    setOwner( owner );
    setSearchLicense( '' );
    setSearchOwner( null );
    setModal( null );

    ref_license.current.value = vehicle.cd_license;

    navigate(`/op/services/${vehicle.cd_license}/${owner.id}`);
  }

  const executeSearch = (search_license) => {
    let license = String(search_license||'').trim().toUpperCase();
    if (!license) return;

    API.findCustomer(license, search_owner).then(resp => {
      if (resp.success)
      {
        let cust = resp.msg;
        if (1 == cust.length)
        { applyOwner(cust[0]); } // apply customer
        else
        {
          // show list and choose
          let modal = <CustomerSelectModal customers={resp.msg} onSelect={applyOwner} />
          setModal(modal);
          setModalTitle('選擇客戶');
        }
      } else {
        PopMessage.show(`車牌 ${license} 不存在。`, '搜尋', 'danger');
        setOwner(null);
        setAttempt(license);
      }
    });
  }

  // -------------------------------------
  // start init
  useEffect(() => {
    executeSearch(search_license);
  }, [search_license]);

  useEffect(() => {
    if (!owner) return;
    refreshBillPayment();
  }, [owner]);

  useEffect(() => {
    if (sel_vehicle ) {
      let path = `/op/services/${sel_vehicle.cd_license}/${sel_vehicle.owner_id}`;
      if (path != window.location.pathname) { navigate(path); }
    }
  }, [sel_vehicle]);

  //---------------------------------------------------------------------
  const showAddVehicleModal = () =>
  {
    let modal = <AddVehicleModal owner={owner} onClose={closeModal} />;
    setModal(modal);
    setModalTitle('新增車輛');
  }
  const showLicenseChangeRecords = () =>
  {
    let modal = <LCRModal owner={owner} onClose={closeModal} />;
    setModal(modal);
    setModalTitle('車牌更改紀錄');
  }
  const closeModal = () =>
  {
    setModal(null);
  }

  const onDeletedVehicle = (vehicle) =>
  {
    if (vehicle) {
      owner.vehicles = owner.vehicles.filter(vh => vh.cd_license != vehicle.cd_license);
      setOwner({...owner});
    }
  }

  //---------------------------------------------------------------------
  return (<>
    <h1>日常操作 - 車輛服務</h1>
    <div className="split">
      { /* Left */ }
      <section>
        <div className="box op-owner-info">
          <h4 className="box-head">車主 { owner && `(${owner.id})` }</h4>
          <div className="box-body">
            <div className="split-2">
              <label className="row field">
                <strong>搜索車牌</strong>
                <div className="txt-btn-grp">
                  <input type="text" defaultValue={search_license} placeholder="車牌號碼" ref={ref_license}
                    onKeyPress={enterPressed(searchLicense)}/>
                  <button className="btn small blue" onClick={searchLicense}>搜索</button>
                </div>
              </label>
              <label className="row field">
                <strong>搜索聯絡</strong>
                <div className="txt-btn-grp">
                  <input type="text" placeholder="電話號碼或電郵地址" ref={ref_contact}
                    onKeyPress={enterPressed(searchContact)}/>
                  <button className="btn small blue" onClick={searchContact}>搜索</button>
                </div>
              </label>
            </div>
            <OwnerInfo owner={owner} />
          </div>
        </div>
        { (!owner)
          ?(!attempt?''
            :<NewCustomerPanel license={attempt} onCreated={onCustCreated}/>
          )
          :(<>
            <div className="box op-vehicle-info">
              <h4 className="box-head action-panel">
                <span>車輛 - 現時服務</span>
                <div className="button-group">
                  <button className="btn small white" onClick={e=>showLicenseChangeRecords()}>車牌轉換紀錄</button>
                  <button className="btn small white" onClick={e=>setShowAllVehicles(!showAllVh)}>
                  { showAllVh
                    ? <FontAwesomeIcon icon={faEyeSlash} />
                    : <FontAwesomeIcon icon={faEye} />
                  }
                  </button>
                  <button className="btn small green" onClick={showAddVehicleModal}>
                    <FontAwesomeIcon icon={faPlus} />
                  </button>
                </div>
              </h4>
              <div className="box-body tbl-vehicle">
                { owner.vehicles.filter(v => showAllVh||!v.deleted).map(v=>
                    <VehicleCard key={v.cd_license} model={v}
                                 onClick={e=>setVehicle(v)} />
                )}
              </div>
            </div>
            <VehicleEdit vehicle={ sel_vehicle } onDeleted={onDeletedVehicle}/>
            <ServiceEdit vehicle={ sel_vehicle } onUpdated={refreshService} />
          </>
        )}
      </section>
      {/* Right */}
      {!!owner &&
        <section className="op-bill-payment">
          <BillList {...billData}
            owner={owner} vehicle={sel_vehicle}
            onUpdated={refreshBillPayment}
          />
          <PaymentList {...billData}
              owner={owner} onUpdated={refreshBillPayment} />
          <OrderList owner={owner}
            selectedVehicleLicense={sel_vehicle.cd_license}
          />
        </section>
      }
    </div>
    <ModalScreen title={modalTitle} show={null != modal} onClose={closeModal}>
      { modal }
    </ModalScreen>
  </>);

}

export default ServiceView;